// b2b列表
export default [
    {
        path: "b2border",
        name: "b2bOrder",
        component: () => import(/* webpackChunkName: "b2border" */ "@/views/boss/b2border/index"),
        
    },
    // b2b订单编辑查看
    {
        path: "b2border/upadte/:type",
        name: "b2bOrderupdate",
        component: () => import(/* webpackChunkName: "b2border" */ "@/views/boss/b2border/update/index"),
        
    },
]